export const ACTIONS_TOOLBAR = {
  DOWNLOAD: 'DOWNLOAD',
  DELETE: 'DELETE',
  MOVE: 'MOVE',
};
